import { defineStore } from 'pinia';

export interface Appearance {
    image: string;
    buttonColor: string;
    fontSizes: string;
}

export interface Department {
    id: string;
    name: string;
    showOnMenu: boolean;
    saleDepartment: boolean;
    taxRate: string;
    displayOrder: number;
    nonDiscountable: boolean;
    nonSurchargeable: boolean;
    scaleDepartment: boolean;
    unitOfSale: string;
    appearance: Appearance;
    altDisplayLang: String[];
}

export const defaultDepartment = {
    id: '',
    name: '',
    showOnMenu: false,
    saleDepartment: false,
    taxRate: '',
    displayOrder: 0,
    nonDiscountable: false,
    nonSurchargeable: false,
    scaleDepartment: false,
    unitOfSale: '',
    appearance: {
        image: '',
        buttonColor: '',
        fontSizes: '',
    },
    altDisplayLang: []
} as Department;

export const departmentsListMock: Department[] = [
    {
        id: '001',
        name: 'Appetizers',
        showOnMenu: true,
        saleDepartment: true,
        taxRate: 'Tax',
        displayOrder: 1,
        nonDiscountable: false,
        nonSurchargeable: false,
        scaleDepartment: false,
        unitOfSale: 'Individually',
        appearance: {
            image: 'https://trueeye.ai/img/Logo%20small.b573b431.png',
            buttonColor: '7',
            fontSizes: 'Medium',
        },
        altDisplayLang: []
    },
    {
        id: '002',
        name: 'Main Course',
        showOnMenu: true,
        saleDepartment: true,
        taxRate: 'Tax2',
        displayOrder: 2,
        nonDiscountable: false,
        nonSurchargeable: false,
        scaleDepartment: false,
        unitOfSale: 'Kilogram',
        appearance: {
            image: '',
            buttonColor: '1',
            fontSizes: 'X-Large',
        },
        altDisplayLang: []
    },
    {
        id: '003',
        name: 'Desserts',
        showOnMenu: true,
        saleDepartment: true,
        taxRate: 'Tax',
        displayOrder: 3,
        nonDiscountable: false,
        nonSurchargeable: false,
        scaleDepartment: false,
        unitOfSale: 'Pound',
        appearance: {
            image: '',
            buttonColor: '8',
            fontSizes: 'Large',
        },
        altDisplayLang: []
    },
    {
        id: '004',
        name: 'Beverages',
        showOnMenu: true,
        saleDepartment: true,
        taxRate: 'Tax3',
        displayOrder: 4,
        nonDiscountable: true,
        nonSurchargeable: true,
        scaleDepartment: true,
        unitOfSale: 'Liter',
        appearance: {
            image: 'https://trueeye.ai/img/Logo%20small.b573b431.png',
            buttonColor: '10',
            fontSizes: 'Small',
        },
        altDisplayLang: []
    },
];

export const useDepartmentsStore = defineStore('departments', {
    state: () => ({
        departmentList: [] as Department[],
        activeDepartment: {} as Department,
        tempActiveDepartment: {} as Department,
    }),
    getters: {
        getActiveDepartment: (state) => {
            return state.activeDepartment;
        },
        getActiveDepartmentId: (state) => {
            return state.activeDepartment.id;
        },
        findDepartmentById: (state) => (id: string) => {
            return state.departmentList.find(department => department.id === id);
        },
        getDepartmentsList: (state) => {
            return state.departmentList;
        },
        getTempActiveDepartment: (state) => {
            return state.tempActiveDepartment;
        },
        getIsActiveDepartmentChanged: (state) => {
            return JSON.stringify(state.activeDepartment) !== JSON.stringify(state.tempActiveDepartment);
        }
    },
    actions: {
        initializeDepartments(departments: Department[]) {
            this.departmentList = departments;
        },
        addDepartment(department: Department) {
            this.departmentList.push(department);
        },
        removeDepartment(id: string) {
            this.departmentList = this.departmentList.filter(department => department.id !== id);
            this.activeDepartment = defaultDepartment;
            this.tempActiveDepartment = defaultDepartment;
        },
        updateDepartment(updatedDepartment: Department) {
            const index = this.departmentList.findIndex(department => department.id === updatedDepartment.id);
            if (index !== -1) {
                this.departmentList[index] = updatedDepartment;
            }
        },
        setActiveDepartment(department: Department) {
            this.activeDepartment = department;
        },
        setTempActiveDepartment(department: Department) {
            this.tempActiveDepartment = department;
        },
        initActiveDepartment(department: Department) {
            this.activeDepartment = department;
            this.tempActiveDepartment = department;
        }

    },
});